import React from 'react';
import Card from '../Card/Card';
import { Grid } from '@material-ui/core';

const CardBlock = ({...props}) => {
    let list = [];
    if(props.list !== undefined){
        list = props.list        
    }

    const renderCards = () => (
        list.length > 0 ?
        list.map((card,index) => (
                <Card key={index} {...card} />
        )) : null
    )
    return (
        <>
        <div className="container">
            <div className='row'>
                <div className="col cardBlock">
                    <div style={{ display:'flex', flexWrap:'wrap' }}>
                        {renderCards(props.list)}
                    </div>
                </div>            
            </div>
        </div>
        </>
    )
};

export default CardBlock;